import { render, staticRenderFns } from "./PrfReceptionResume.vue?vue&type=template&id=31f051b5"
import script from "./PrfReceptionResume.vue?vue&type=script&lang=js"
export * from "./PrfReceptionResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports